import React from 'react';
import './Tabs.css';

function Tabs({ activeTab, setActiveTab }) {
  const tabs = [
    { id: 'vista',     label: 'Vista general',   icon: 'ti ti-table' },
    { id: 'analytics', label: 'Análisis',         icon: 'ti ti-chart-line' },
    { id: 'manual',    label: 'Entrada manual',   icon: 'ti ti-edit' },
  ];

  return (
    <div className="tabs-nav">
      {tabs.map(tab => (
        <div
          key={tab.id}
          className={`tab ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => setActiveTab(tab.id)}
        >
          <i className={tab.icon} style={{ fontSize: 13 }}></i>
          {tab.label}
          {tab.badge && (
            <span className="tab-badge">{tab.badge}</span>
          )}
        </div>
      ))}
    </div>
  );
}

export default Tabs;
